import './index.less'

(function () {
  const search_main = document.querySelector(".product-with-result")
  const result_amount = document.querySelectorAll(".result-toolbar--text span block")
  const product_grid = document.querySelector(".result-product-grid")
  const filters_main = document.querySelector(".filters-container")
  const filters_groups = document.querySelector(".filters-group-container-filter")
  const compare_wrapper = document.querySelector('v5-collection-sticky-bottom-compare')
  const next_mb = document.querySelector(".collection-pagination-wrapper--mb")
  let __page_index = 1
  let __page_count = 1
  let loading_next = false;
  let __pagination_listener_bound = false;
  const mql = window.matchMedia('(max-width: 1024px)');
  const show_compare = document.querySelector(".collection-wrapper").getAttribute("data-show_compare") === "true"
  const fk_no_data = document.querySelector(".no_data_main")
  const selectedFilters = document.querySelector(".selected-filters")

  // 获取 header 高度
  function getHeaderHeight() {
    return parseFloat(getComputedStyle(document.querySelector("body")).getPropertyValue("--jky-header-h")) || 0
  }

  // 动态创建响应式图片
  function createResponsiveIMG(url, alt) {
    const baseUrl = url.split('?')[0];
    const widths = [300, 450, 600, 750, 900, 1050, 1200, 1350, 1500, 1650, 1800, 1950, 2000, 2500];
    const srcset = widths.map(width => `${baseUrl}?width=${width} ${width}w`).join(', ');

    return `
      <img class="w-full p__img" 
        loading="lazy" 
        src="${baseUrl}?width=345" 
        srcset="${srcset}"
        sizes="auto, (min-width: 1024px) 21.57rem, (max-width: 1024px) 92vw"
        alt="${alt}">
    `;
  }

  function createResponsiveTAG(url, alt) {
    const baseUrl = url.split('?')[0];
    return `<img class="w-7 h-7 object-contain flex-shrink-0" loading="lazy" src="${baseUrl}?width=56" alt="${alt}">`;
  }

  function renderOptions(list, name = '') {
    if (!Array.isArray(list)) return ''
    if (!list.length) return ''
    let res = ''
    list.forEach(option => {
      res += `
        <div 
          item-id="${option.itemId}" 
          selectFlag="${option.selectFlag}" class="trigger-group-option flex gap-2 mb-2 active ${!option.selectFlag ? 'opacity-40 pointer-events-none' : ''}"
        >
          <div class="zc-checkbox checkbox-label-alignment-start checkbox-label-placement-fixed">
            <label class="checkbox-wrapper">
              <div class="label-text-wrapper text-[#242F20]" part="label">
                <span class="text-sm">${option.itemName}</span>
              </div>
              <input 
                data-ga-event="product_collection4.0_user_clicks" 
                data-ga-action="change"
                data-ga-params-module="Filters"
                data-ga-params-position="${name}"
                data-ga-params-button_name="${option.itemName}"
                type="checkbox" data-value="${option.itemId}">
              <div class="native-wrapper">
                <svg class="checkbox-icon" viewBox="0 0 24 24"
                  part="container">
                  <path d="M1.73,12.91 8.1,19.28 22.79,4.59" part="mark"></path>
                </svg>
              </div>
            </label>
          </div>
        </div>
      `
    })
    return res
  }

  function renderFilterGroups(list) {
    if (!Array.isArray(list)) return ''
    if (!list.length) return ''
    let res = ''
    list.forEach((item, index) => {
      res += `
        <collection-drop-down init="open" class="filters-group-dropdown_main pl-4 pr-2.5 py-2.5 lg:p-0 border-0 border-solid border-b-[1px] border-[#C3C3BE] last-of-type:border-b-0 lg:border-b-0" doc="false">
          <div trigger>
            <div class="flex items-center justify-between min-h-9 lg:min-h-6 gap-x-6">
              <span class="flex-1 font-semibold text-[#242F20] lg:text-base">${item.itemName}</span>
              <svg class="trigger-group--icon transition-transform duration-300 flex-shrink-0 text-black/65 lg:w-6 lg:h-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.27246 9L12.2725 15L18.2725 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>

          <div trigger-content>
            <div class="trigger--detail mt-2.5 lg:mt-[1.125rem]">
              ${item.childrenList.length ? renderOptions(item.childrenList, item.itemName) : ''}
            </div>
          </div>
        </collection-drop-down>
      `
    })
    return res
  }

  function setOptionStatus(list) {
    list.forEach(item => {
      if (Array.isArray(item.childrenList)) {
        item.childrenList.forEach(option => {
          const target = document.querySelector(`[item-id='${option.itemId}']`)
          if (!target) return
          if (!option.selectFlag) {
            target.classList.add('opacity-40', 'pointer-events-none')
          } else {
            target.classList.remove('opacity-40', 'pointer-events-none')
          }
        })
      }
    })
  }

  function renderProductList(list, next = false, count = 0) {
    if (!Array.isArray(list)) return ''
    if (!count) {
      product_grid.innerHTML = ''
      fk_no_data.classList.add("active")
      return ''
    } else {
      fk_no_data.classList.remove("active")
    }
    if (!list.length) return;
    const open_new = document.querySelector(".collection-wrapper").getAttribute("data-open") === "true"
    // 是否开启了 自动折扣价
    const open_auto_discount_price = document.querySelector(".collection-wrapper").getAttribute("data-open-auto-discount-price") === "true"
    // 折扣角标
    const data_discount_tag_display_style = document.querySelector(".collection-wrapper").getAttribute("data-discount-tag-display-style")
    const discount_amount_display_style = document.querySelector(".collection-wrapper").getAttribute("data-discount-amount-display-style")
    const discount_percent_display_style = document.querySelector(".collection-wrapper").getAttribute("data-discount-percent-display-style")
    let res = ''
    list.forEach(item => {
      const current_price = Math.min(item.autoDiscountPrice || 0, item.shopifyFrontprice || 0)
      const origin_price = Math.max(item.autoDiscountPrice || 0, item.shopifyFrontprice || 0, item.shopifyFrontOriginalPrice || 0)
      let money_format = window?.pageInfo?.currency?.money_format?.replace('{{amount}}', '{{amount_no_decimals}}')
      money_format = money_format?.replace('{{amount_with_comma_separator}}', '{{amount_no_decimals_with_comma_separator}}')
      const discount_amount = formatMoney(Math.floor(item.autoDiscountAmount / 100) * 100, money_format)
      res += `
        <div class="collection-product-item" goods-id="${item.goodsId}" data-sku="${item.skuId}">
          <div class="w-full px-3 lg:px-5 pt-5 absolute left-0 top-0 z-[3] flex items-center justify-between gap-x-2.5">
            <div class="flex items-center gap-x-2.5 h-7">
              ${item.variantTag ? `<span class="font-semibold text-xs lg:text-base h-full px-2 bg-[#242F20] text-white flex items-center">${item.variantTag}</span>` : ''}
              ${item.promotion
                ? '<span class="font-semibold text-xs lg:text-base h-full px-2 bg-primary text-white flex items-center">' + item.promotion + '</span>'
                : open_auto_discount_price
                  ? data_discount_tag_display_style === 'amount'
                    ? item.autoDiscountAmount > 0 ? `<span class="font-semibold text-xs lg:text-base h-full px-2 bg-primary text-white flex items-center">${discount_amount_display_style.replace('()', discount_amount)}</span>` : ''
                    : item.autoDiscountPercentage > 0 ? `<span class="font-semibold text-xs lg:text-base h-full px-2 bg-primary text-white flex items-center">${discount_percent_display_style.replace('()', item.autoDiscountPercentage)}</span>` : ''
                  : ''
              }
            </div>
            ${item.productTagImage ? createResponsiveTAG(item.productTagImage, item.title) : ''}
          </div>
          <div class="collection-product-card">
            <a 
              aria-label="Collection-product-Card"
              data-ga-event="product_collection4.0_user_clicks" 
              data-ga-action="click"
              data-ga-params-module="Product"
              data-ga-params-link="${item.goodsUrl}"
              data-ga-params-position="${item.title}"
              data-ga-params-button_name="${item.saleFlag ? pageInfo.strings.collection.addToCart : pageInfo.strings.collection.soldOut}"
              ${open_new ? 'target="_blank"' : ''}
              style="position: absolute;width:100%;height: 100%;top: 0;left:0;" href="${item.goodsUrl}"></a>
            <a 
              ${open_new ? 'target="_blank"' : ''} 
              href="${item.goodsUrl}"
              aria-label="Collection-product-Card"
              data-ga-event="product_collection4.0_user_clicks" 
              data-ga-action="click"
              data-ga-params-module="Product"
              data-ga-params-link="${item.goodsUrl}"
              data-ga-params-position="${item.title}"
              data-ga-params-button_name="${item.saleFlag ? pageInfo.strings.collection.addToCart : pageInfo.strings.collection.soldOut}"
            >
              ${createResponsiveIMG(item.image, item.title)}
            </a>
            <div class="flex items-center mb-3 gap-x-3">
              <collection-star-rating class="lg:-mt-0.5" score="${item.reviewRating || 0}"></collection-star-rating>
              <span class="text-sm text-black/65">${item.reviewRating ? item.reviewRating.toFixed(1) : '0.0'} ${item.reviewCount > 0 ? `(${item.reviewCount})` : ''}</span>
            </div>
            <div class="flex-1 flex flex-col justify-between relative z-[3]">
              <div class="flex flex-col gap-y-2">
                <a 
                  aria-label="Collection-product-Card"
                  data-ga-event="product_collection4.0_user_clicks" 
                  data-ga-action="click"
                  data-ga-params-module="Product"
                  data-ga-params-link="${item.goodsUrl}"
                  data-ga-params-position="${item.title}"
                  data-ga-params-button_name="${item.saleFlag ? pageInfo.strings.collection.addToCart : pageInfo.strings.collection.soldOut}"
                  ${open_new ? 'target="_blank"' : ''} href="${item.goodsUrl}" class="text-overflow-2 font-semibold text-black/90 text-base lg:text-xl">${item.title}</a>
                <div class="text-overflow-2 text-[#94948F] lg:text-[#A9AAAC] text-xs lg:text-sm">${item.productFeaturesInfoList ? item.productFeaturesInfoList.join('<br>') : ''}</div>
              </div>
    
              <div class="flex flex-col gap-y-3 mt-4 lg:gap-y-4">
                <div class="flex items-baseline gap-x-1">
                  ${open_auto_discount_price && item.autoDiscountPrice > 0
                    ? `<span class="font-semibold text-[#242F20] text-xl">${formatMoney(current_price, pageInfo.currency.money_format)}</span>`
                    : `<span class="font-semibold text-[#242F20] text-xl">${formatMoney(item.shopifyFrontprice, pageInfo.currency.money_format)}</span>`
                  }
                  ${open_auto_discount_price && item.autoDiscountPrice > 0
                    ? `<span class="text-black/65 text-sm line-through">${origin_price > current_price ? formatMoney(origin_price, pageInfo.currency.money_format) : ''}</span>`
                    : `<span class="text-black/65 text-sm line-through">${item.shopifyFrontOriginalPrice ? formatMoney(item.shopifyFrontOriginalPrice, pageInfo.currency.money_format) : ''}</span>`
                  }
                </div>
                
                <div class="flex items-center justify-between lg:h-8">
                  <a href="${item.goodsUrl}" ${open_new ? 'target="_blank"' : ''} class="shop-now font-semibold text-primary flex items-center text-base lg:text-xl gap-x-2">
                    ${pageInfo.strings.collection.shopNow}
                    <svg class="text-primary" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_4559_7516)">
                        <path d="M-1 9.25H11.2422" stroke="currentColor" stroke-width="1.6"/>
                        <path d="M8.49219 3L14.7419 9.24976L8.49219 15.4995" stroke="currentColor" stroke-width="1.6"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_4559_7516">
                          <rect width="16" height="16" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                  <div class="collection-product--compare ${show_compare ? 'flex justify-center' : 'hidden'}" goods-id="${item.goodsId}" data-sku="${item.skuId}" data-title="${item.title}" data-image="${item.image}">
                    <div class="zc-checkbox checkbox-label-alignment-start checkbox-label-placement-fixed">
                      <label class="checkbox-wrapper">
                        <div class="label-text-wrapper text-[#242F20]" part="label">
                          <span class="text-xs lg:text-base !leading-none">${pageInfo.strings.collection.compare_button_text}</span>
                        </div>
                        <input type="checkbox">
                        <div class="native-wrapper">
                          <svg class="checkbox-icon" viewBox="0 0 24 24" part="container">
                            <path d="M1.73,12.91 8.1,19.28 22.79,4.59" part="mark"></path>
                          </svg>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `
    })

    if (next) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = res;
      const fragment = document.createDocumentFragment();
      while (tempDiv.firstChild) {
        fragment.appendChild(tempDiv.firstChild);
      }

      if (window.innerWidth >= 1024) {
        product_grid.innerHTML = ''
        product_grid.appendChild(fragment);
      } else {
        product_grid.appendChild(fragment);
      }
    } else {
      product_grid.innerHTML = res
    }

    if (show_compare) {
      setTimeout(() => {
        try {
          const selectedSkuSet = new Set((document.querySelector('v5-collection-sticky-bottom-compare')?.compare_products || []).map(item => item?.skuId?.toString()))
          document.querySelectorAll(".collection-product--compare").forEach(wrapper => {
            const sku = String(wrapper.getAttribute("data-sku") || "")
            const input = wrapper.querySelector("input[type='checkbox']")
            if (!input) return
            if (selectedSkuSet.has(sku)) {
              input.checked = true
            } else {
              input.checked = false
            }
          })
        } catch (e) {
          console.warn("sync compare checkboxes error", e)
        }
      }, 50)
    }
  }

  function handleCollectionCount(count = 0) {
    const _dom = document.querySelector(".collection--heading-count")
    if (!_dom) return
    _dom.textContent = _dom.textContent.replace("$count", count)
    _dom.classList.add("is-active");
  }

  function fetchList(init = false, params = {}, next = false) {
    if (loading_next) return
    if (next) { loading_next = true; }
    !next && search_main.classList.remove("loaded")

    document.querySelectorAll(".filters-group-container-filter collection-drop-down .trigger-group-option .zc-checkbox").forEach(i => i.classList.add("checkbox-disabled"))
    document.querySelector("collection-drop-down.filters-toolbar-dropdown_main").classList.add('opacity-40', 'pointer-events-none')
    const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    !init && !next && window.scrollTo({
      top: document.querySelector(".collection-wrapper").getBoundingClientRect().y + scrollTop - Math.floor(getHeaderHeight()),
      behavior: 'smooth'
    });

    const config = fetchConfig("POST")
    config.body = JSON.stringify({
      "shopifyShopId": pageInfo.shopId,
      "categoryName": document.querySelector(".collection-wrapper").getAttribute("data-handle"),
      "limit": window.innerWidth >= 1024 ? 12 : 6,
      "apiVersion": 5,
      ...params
    })
    fetch(`${pageInfo.api}/osconsumerapi/v1/category/product`, config)
      .then((response) => response.json())
      .then((res) => {
        setTimeout(() => {
          document.querySelectorAll(".filters-group-container-filter collection-drop-down .trigger-group-option .zc-checkbox").forEach(i => i.classList.remove("checkbox-disabled"))
        }, 0);
        const _products = res?.data?.productRespPage?.data || []
        loading_next = false

        if (init) {
          filters_main.classList.add("loaded")
          const _inner = renderFilterGroups(res?.data?.cusCategoryItemResps || [])
          filters_groups.innerHTML = _inner
          document.querySelectorAll(".filters-group-container-filter collection-drop-down .trigger-group-option").forEach(item => {
            item.querySelector("input").addEventListener("change", function (e) {
              if (e?.target?.checked) {
                renderSelectedFilter(item.getAttribute("item-id"))
              } else {
                handleDeleteFilter(item.getAttribute("item-id"))
              }

              __page_index = 1
              updatePaginationNum(1)
              updateBtnStatus()
              FormatSearchParams()

              try {
                document.querySelector(".sheetButtons--clear")?.click()
              } catch (error) {
                console.warn("sheetButtons--clear click error")
              }
            })
          })

          handleGaEvents(filters_groups)

          // 接口需要新加字段-数量总和
          handleCollectionCount(res?.data?.productRespPage?.allCount)

          // 初始化已选择搜索条件
          if (params.itemIdList && params.itemIdList && Array.isArray(params.itemIdList)) {
            params.itemIdList.forEach(id => renderSelectedFilter(id))

            // 更新过滤条件数量
            document.querySelector(".filters-trigger").querySelector(".filters-num").textContent = params.itemIdList.length > 0 ? `(${params.itemIdList.length})` : ''
          }

          updatePaginationNum(__page_index)
        } else {
          setOptionStatus(res?.data?.cusCategoryItemResps || [])
        }
        renderProductList(res?.data?.productRespPage?.data || [], next, res?.data?.productRespPage?.count || 0)
        handleGaEvents(document.querySelector(".result-product-grid"))

        try {
          setTimeout(() => {
            result_amount.forEach(item => item.innerHTML = res?.data?.productRespPage?.count || 0)
          }, 20);
          handleMobilePaginationStatus(_products.length ? res?.data?.productRespPage?.count : 0)
        } catch (error) {
          console.log(error)
        }

        // 分页-初始化分页总数
        __page_count = Math.ceil(res?.data?.productRespPage?.count / 12) || 1
        updatePaginationCount(__page_count)

        search_main.classList.add("loaded")
        document.querySelector("collection-drop-down.filters-toolbar-dropdown_main").classList.remove('opacity-40', 'pointer-events-none')
        init && initFiltersStatus(params)
      })
  }

  function updateQuery(params = {}) {
    if (!params.itemIdList) return
    if (!Array.isArray(params.itemIdList)) return ''
    let res = ''
    if (params.itemIdList.length) {
      res = window.innerWidth >= 1024 ? `?itemIds=${params.itemIdList.join('+')}&sort_by=${params.sortBy}&page=${__page_index}` : `?itemIds=${params.itemIdList.join('+')}&sort_by=${params.sortBy}`
    } else {
      res = window.innerWidth >= 1024 ? `?sort_by=${params.sortBy}&page=${__page_index}` : `?sort_by=${params.sortBy}`
    }
    window.history.replaceState({}, '', `${location.pathname}${res}`);

    // 更新过滤条件数量
    document.querySelector(".filters-trigger").querySelector(".filters-num").textContent = params.itemIdList.length > 0 ? `(${params.itemIdList.length})` : ''
  }

  function initFiltersStatus(params = {}) {
    if (params.itemIdList) {
      if (Array.isArray(params.itemIdList)) {
        params.itemIdList.forEach(item => {
          const target = document.querySelector(`.filters-group-container-filter [item-id='${item}']`)

          if (!target) return
          target.classList.add('active')
          target.querySelector("input").checked = true
        })
      }
    }

    const pc_sort_target = document.querySelector(`[data-pc-value='${params.sortBy}']`)
    if (pc_sort_target) {
      document.querySelectorAll("collection-drop-down.filters-toolbar-dropdown_main .trigger--detail-item").forEach(option => option.classList.remove("active"))
      pc_sort_target.classList.add("active")
      document.querySelector("collection-drop-down .trigger--summery span.text-overflow-1").innerHTML = pc_sort_target.innerHTML
    }

    const mb_sort_target = document.querySelector(`[data-mb-value='${params.sortBy}']`)
    if (mb_sort_target) {
      document.querySelectorAll(".filters-group-container-sort [data-mb-value]").forEach(item => item.checked = false)
      mb_sort_target.checked = true
    }
  }

  function initQuery() {
    let url = window.location.href;
    let queryString = url.split('?')[1];
    let queryParams = {};
    if (queryString) {
      let pairs = queryString.split('&');
      for (let i = 0; i < pairs.length; i++) {
        let pair = pairs[i].split('=');
        let key = decodeURIComponent(pair[0]);
        let value = decodeURIComponent(pair[1]);
        queryParams[key] = value;
      }
    }

    __page_index = Number(queryParams.page) || 1
    __page_index !== 1 && updatePaginationNum(__page_index)
    const _params = {
      itemIdList: queryParams.itemIds !== "undefined" ? (queryParams.itemIds?.split("+") || []) : [],
      sortBy: queryParams.sort_by
    }
    window.innerWidth >= 1024 && (_params.page = queryParams.page || 1)
    fetchList(true, { ..._params }, false)

    if (show_compare) {
      compare_wrapper?.handleEventCompareClear?.()
      const compare_icons = compare_wrapper?.querySelectorAll?.(".compare-remove-icon");
      compare_icons && compare_icons.forEach(item => {
        item.addEventListener("click", () => {
          compare_wrapper?.handleRemoveCompareItem?.()
        })
      })
      compare_wrapper?.handleCompareStart?.()
    }

    fk_no_data.querySelector(".zc_button").addEventListener("click", clearAllFilters)
  }
  initQuery()

  function FormatSearchParams(next = false) {
    const sort = document.querySelector("collection-drop-down.filters-toolbar-dropdown_main")
    let res = []
    document.querySelectorAll(".filters-group-container-filter collection-drop-down").forEach(dropDown => {
      dropDown.querySelectorAll(".trigger-group-option input").forEach(input_checkbox => {
        input_checkbox.checked && res.push(input_checkbox.getAttribute("data-value"))
      })
    })
    const _params = { itemIdList: res, sortBy: sort?.querySelector(".trigger--detail-item.active")?.getAttribute("data-pc-value"), page: __page_index }

    updateQuery(_params)

    !next && fetchList(false, { itemIdList: res, sortBy: sort?.querySelector(".trigger--detail-item.active")?.getAttribute("data-pc-value"), page: __page_index })
    return _params;
  }


  /* 更新已选搜索条件 */
  function renderSelectedFilter(ids) {
    if (!ids) return;
    const _target = selectedFilters.querySelector(`.selected-filters-item[item-id="${ids}"]`);
    if (_target) return;

    const text = document.querySelector(`.trigger--detail [item-id='${ids}'] .label-text-wrapper span`)?.textContent || ''
    const html = `
      <div item-id="${ids}" class="selected-filters-item flex items-center h-7 gap-1.5 border border-solid border-[#242F20]/90 pl-3 pr-0.5">
        <span class="text-overflow-1 text-sm lg:text-base text-[#242F20]">${text}</span>
        <svg class="selected-filters-close text-black/65" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.79185 17L7 16.2082L11.2082 12L7 7.79185L7.79185 7L12 11.2082L16.2082 7L17 7.79185L12.7918 12L17 16.2082L16.2082 17L12 12.7918L7.79185 17Z" fill="currentColor" />
        </svg>
      </div>
    `
    let range = document.createRange();
    let fragment = range.createContextualFragment(html);
    fragment.querySelector(".selected-filters-close").addEventListener("click", () => {
      const _input = document.querySelector(`.trigger--detail [item-id='${ids}'] input`)
      if (_input) {
        _input.checked = false
        const event = new Event('change', { bubbles: true, cancelable: true });
        _input.dispatchEvent(event);
      }
    })
    selectedFilters.insertBefore(fragment, selectedFilters.querySelector(".selected-filters-clear"));
    selectedFilters.classList.remove("hide")
  }

  function handleDeleteFilter(ids) {
    if (!ids) return
    const target = selectedFilters.querySelector(`.selected-filters-item[item-id="${ids}"]`);
    target && target.remove()
    if (!selectedFilters.querySelectorAll(".selected-filters-item")?.length) {
      selectedFilters.classList.add("hide")
    }
  }


  selectedFilters.querySelector(".selected-filters-clear") && selectedFilters.querySelector(".selected-filters-clear").addEventListener("click", () => {
    selectedFilters.querySelectorAll(".selected-filters-item").forEach(item => {
      item.remove()
      selectedFilters.classList.add("hide")
    })
    clearAllFilters()
  })
  /* 更新已选搜索条件 */

  /* 分页控制 - start */
  function updatePaginationNum(num = 1) { // 更新分页-当前页数
    const dom = document.querySelector("collection-pagination")
    if (!dom) return
    dom.setAttribute("current", num || 1)
  }
  function updatePaginationCount(num = 0) { // 更新分页-总页数(初始化)
    const dom = document.querySelector("collection-pagination")
    if (!dom) return
    dom.setAttribute("total", num || 1)

    if (num === 0) {
      dom.querySelector(".collection-pagination-wrapper").classList.add("hide")
    } else {
      dom.querySelector(".collection-pagination-wrapper").classList.remove("hide")
    }

    setTimeout(() => { updateBtnStatus() }, 2000);

    // 监听分页组件变化
    // 新 main-product 触发variant变化 - 改变当前变体
    if (document.querySelector('collection-pagination')) {
      if (!__pagination_listener_bound) {
        document.addEventListener('collection:pagination-change', onPaginationChange)
        __pagination_listener_bound = true
      }
    }
  }
  function onPaginationChange(e) {
    __page_index = e.detail.page
    updatePaginationNum(__page_index)
    updateBtnStatus()
    FormatSearchParams();
  }
  function updateBtnStatus() { // 更新分页按钮状态
    const dom = document.querySelector("collection-pagination")
    if (!dom) return

    const wrapper = dom.querySelector(".collection-pagination-wrapper")
    const next = wrapper.querySelector(".collection-pagination__next")
    const prev = wrapper.querySelector(".collection-pagination__prev")

    try {
      if (__page_index == 1) {
        prev.classList.add("is-disabled")
      } else {
        prev.classList.remove("is-disabled")
      }

      if (__page_index == __page_count) {
        next.classList.add("is-disabled")
      } else {
        next.classList.remove("is-disabled")
      }
    } catch (error) {
      console.warn("updateBtnStatus error", error)
    }
  }
  function LoadNext() {
    if (loading_next) return
    __page_index = __page_index + 1
    const params = FormatSearchParams(true)
    fetchList(false, params, true)
  }

  function handleMobilePaginationStatus(count = 0) {
    if (window.innerWidth < 1024) {
      if (count <= 6) {
        next_mb && next_mb.classList.add("hide")
      } else {
        next_mb && next_mb.classList.remove("hide")
      }
    }
  }

  window.innerWidth < 1024 && next_mb.addEventListener("click", () => { LoadNext() })
  /* 分页控制 - end */

  function clearAllFilters() {
    document.querySelectorAll(".filters-group-container-filter collection-drop-down").forEach(dropDown => {
      dropDown.querySelectorAll(".trigger-group-option input").forEach(input_checkbox => {
        if (input_checkbox.checked) {
          input_checkbox.checked = false
        }
      })
    })

    selectedFilters.querySelectorAll(".selected-filters-item").forEach(item => {
      item.remove()
      selectedFilters.classList.add("hide")
    })

    const params = FormatSearchParams(false)
    fetchList(false, params, false)
    fk_no_data.classList.remove("active")
  }

  // PC端 下拉选择
  document.querySelectorAll("collection-drop-down.filters-toolbar-dropdown_main .trigger--detail-item").forEach(item => {
    item.addEventListener("click", function () {
      __page_index = 1
      updatePaginationNum(1)
      updateBtnStatus()

      document.querySelectorAll("collection-drop-down.filters-toolbar-dropdown_main .trigger--detail-item").forEach(_i => _i.classList.remove("active"))
      this.classList.add("active")
      document.querySelector("collection-drop-down.filters-toolbar-dropdown_main .trigger--summery span.text-overflow-1").innerText = this.innerText
      document.querySelector("collection-drop-down.filters-toolbar-dropdown_main")?.close()

      const sort_by_value = item.getAttribute('data-pc-value')

      // 清空全部
      document.querySelectorAll('.filters-group-container-sort [data-mb-value]').forEach(t => t.checked = false)
      document.querySelector(`.filters-group-container-sort [data-mb-value="${sort_by_value}"]`).checked = true

      FormatSearchParams()

      try {
        document.querySelector(".sheetButtons--clear")?.click()
      } catch (error) {
        console.warn("sheetButtons--clear click error")
      }
    })
  })

  // 移动端 排序选择
  document.querySelectorAll('.filters-group-container-sort [data-mb-value]').forEach(item => {
    item.addEventListener("change", function (e) {
      __page_index = 1
      updatePaginationNum(1)
      updateBtnStatus()

      // 清空全部
      document.querySelectorAll('.filters-group-container-sort [data-mb-value]').forEach(t => t.checked = false)
      item.checked = true

      const sort_by_value = item.getAttribute('data-mb-value')

      // 更新 PC 下拉选择
      document.querySelectorAll("collection-drop-down.filters-toolbar-dropdown_main .trigger--detail-item").forEach(_i => _i.classList.remove("active"))
      document.querySelector(`collection-drop-down.filters-toolbar-dropdown_main .trigger--detail-item[data-pc-value="${sort_by_value}"]`).classList.add('active')
      document.querySelector("collection-drop-down.filters-toolbar-dropdown_main .trigger--summery span.text-overflow-1").innerText = sort_by_value

      FormatSearchParams()

      try {
        document.querySelector(".sheetButtons--clear")?.click()
      } catch (error) {
        console.warn("sheetButtons--clear click error")
      }
    })
  })

  if (mql.matches) {
    document.querySelector(".filters-trigger").addEventListener("click", (e) => {
      const parentEle = e.currentTarget.parentElement
      const { height, top } = parentEle.getBoundingClientRect()

      const headerH = getHeaderHeight()
      
      document.querySelector("body").style.setProperty('--header-bottom-position', `${Math.floor(headerH) + height}px`);

      if (Math.floor(top) > Math.floor(headerH)) {
        const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0
        const t = Math.max(0, Math.floor(scrollTop + top - headerH))
        window.scrollTo({
          top: t,
          behavior: 'smooth'
        })
      }

      document.querySelector(".filters-container").classList.add("open")
      document.querySelector(".filters--overlay").classList.add("active")
      document.querySelector("body").classList.add("overflow-hidden")
    })

    document.querySelector(".filters--btn-close").addEventListener("click", () => {
      document.querySelector(".filters-container").classList.remove("open")
      document.querySelector(".filters--overlay").classList.remove("active")
      document.querySelector("body").classList.remove("overflow-hidden")
    })

    document.querySelector(".filters--overlay").addEventListener("click", () => {
      document.querySelector(".filters-container").classList.remove("open")
      document.querySelector(".filters--overlay").classList.remove("active")
      document.querySelector("body").classList.remove("overflow-hidden")
    })
  }

  // 自定义下拉组件
  class CollectionDropDown extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector("[trigger]")
      this.content = this.querySelector("[trigger-content]")
      this.unDocClickAble = this.getAttribute("doc") === "false"
      this.init_open = this.getAttribute("init") === "open"
      if (this.trigger && this.content) {
        this.initClickTrigger()
        !this.unDocClickAble && document.addEventListener("click", this.docClick.bind(this))
      }
    }
    connectedCallback() {
      this.init_open && this.open()
    }
    disconnectedCallback() {
      this.trigger.removeEventListener("click", this.handleClick.bind(this))
      !this.unDocClickAble && document.removeEventListener("click", this.docClick.bind(this))
    }
    handleClick(e) {
      e.preventDefault()
      this.hasAttribute("open") ? this.close() : this.open()
    }
    initClickTrigger() {
      this.trigger.addEventListener("click", this.handleClick.bind(this))
    }
    docClick(e) {
      if (this.contains(e.target)) return;
      this.close()
    }
    open() {
      if (this.classList.contains("closing")) return
      this.classList.add("opending")
      this.setAttribute("open", !0)
      this.setAttribute("aria-expanded", !0)
      this.content.style.display = "block"
      const height = this.content.scrollHeight;
      this.content.style.maxHeight = height + 'px';
      setTimeout(() => {
        this.classList.remove("opending")
      }, 300);
    }
    close() {
      if (this.classList.contains("opending")) return
      this.classList.add("closing")
      this.removeAttribute("open")
      this.setAttribute("aria-expanded", !1)
      this.content.style.maxHeight = '0';
      setTimeout(() => {
        this.content.style.display = 'none';
        this.classList.remove("closing")
      }, 300);
    }
  }
  customElements.define("collection-drop-down", CollectionDropDown)

  // 评分星级组件
  class CollectionStarRating extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
      const score = parseFloat(this.getAttribute('score')) || 0;
      const starWidth = 15;
      const gap = 5; // 0.3125rem
      const totalWidth = (starWidth * 5) + (gap * 4);

      // 计算裁剪宽度
      const fullStars = Math.floor(score);
      const decimal = score - fullStars;
      const fillWidth = (fullStars * starWidth) + (fullStars * gap) + (decimal * starWidth);

      this.shadowRoot.innerHTML = `
        <style>
          :host { display: inline-block; vertical-align: middle; }
          svg { display: block; }
        </style>
        <svg width="${totalWidth}" height="15" viewBox="0 0 ${totalWidth} 15">
          <defs>
            <symbol id="s" viewBox="0 0 15 15">
              <path d="M2.80511 15L4.5628 9.24107L0 5.98336H5.68158L7.5 0L9.31842 5.98336H15L10.4372 9.24107L12.1949 15L7.5 11.4598L2.80511 15Z" />
            </symbol>
            <clipPath id="c">
              <rect x="0" y="0" width="${fillWidth}" height="15" />
            </clipPath>
          </defs>
          <g fill="#E0E0E0">
            ${[0, 1, 2, 3, 4].map(i => `<use href="#s" x="${i * (starWidth + gap)}" width="15" height="15"/>`).join('')}
          </g>
          <g fill="#FFB501" clip-path="url(#c)">
            ${[0, 1, 2, 3, 4].map(i => `<use href="#s" x="${i * (starWidth + gap)}" width="15" height="15"/>`).join('')}
          </g>
        </svg>
      `;
    }
  }
  customElements.define('collection-star-rating', CollectionStarRating);

  // 分页组件
  class CollectionPagination extends HTMLElement {
    constructor() {
      super();
    }
    static get observedAttributes() {
      return ['total', 'current'];
    }
    // 属性变化监听
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue !== newValue && this.isMounted) {
        this.render();
      }
    }
    // 映射属性到 DOM 对象
    get total() { return parseInt(this.getAttribute('total')) || 1; }
    set total(val) { this.setAttribute('total', val); }
    get current() { return parseInt(this.getAttribute('current')) || 1; }
    set current(val) { this.setAttribute('current', val); }

    // 内部逻辑：计算页码数组
    getPages() {
      const pages = [];
      const { total, current } = this;
      if (total <= 5) {
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        pages.push(1);
        if (current <= 3) {
          for (let i = 2; i <= 4; i++) pages.push(i);
          pages.push('...');
        } else if (current >= total - 2) {
          pages.push('...');
          for (let i = total - 3; i <= total - 1; i++) pages.push(i);
        } else {
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) pages.push(i);
          pages.push('...');
        }
        pages.push(total);
      }
      return pages;
    }

    // 渲染函数
    render() {
      const pages = this.getPages();
      const { total, current } = this;

      // 直接修改 innerHTML，样式需在外部 CSS 文件或全局 <style> 中定义
      this.innerHTML = `
        <div class="collection-pagination-wrapper justify-center items-center hidden lg:flex pt-6 gap-4 lg:pt-10 text-base font-normal text-[#333333]">
          <div class="collection-pagination__prev collection-pagination__item is-disabled w-[3.75rem] h-[3.75rem] rounded-full flex text-center justify-center items-center cursor-pointer ${current === 1 ? 'is-disabled' : ''}" data-page="${current - 1}">
            <svg class="v5-icon-left-arrow collection-pagination__icon" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect class="icon-bg" x="0.5" y="0.5" width="38" height="38" rx="19" fill="white" fill-opacity="0.5"/>
              <rect x="-0.5" y="0.5" width="38" height="38" rx="19" transform="matrix(-1 0 0 1 38 0)" stroke="black" />
              <g clip-path="url(#v5-icon-left-arrow-clip)">
                <path d="M28.5 20.25H16.2578" stroke="#242F20" stroke-width="1.6" />
                <path d="M19.0078 14L12.7581 20.2498L19.0078 26.4995" stroke="#242F20" stroke-width="1.6" />
              </g>
              <defs>
                <clipPath id="v5-icon-left-arrow-clip">
                  <rect width="17" height="16" fill="white" transform="matrix(-1 0 0 1 28.5 12)" />
                </clipPath>
              </defs>
            </svg>
          </div>
          ${pages.map(p => p === '...'
        ? `<span class="w-[3.75rem] h-[3.75rem] rounded-full flex text-center justify-center items-center cursor-pointer font-semibold text-base text-[#A9AAAC] hover:text-[#8A8A8A]">...</span>`
        : `<span class="w-[3.75rem] h-[3.75rem] rounded-full flex text-center justify-center items-center cursor-pointer font-semibold text-base ${current === p ? 'text-[#242F20]' : 'text-[#A9AAAC] hover:text-[#8A8A8A]'}" data-page="${p}">${p}</span>`
      ).join('')}
          <div class="collection-pagination__next collection-pagination__item is-disabled w-12 h-12 rounded-full flex text-center justify-center items-center cursor-pointer ${current === total ? 'is-disabled' : ''}" data-page="${current + 1}">
            <svg class="v5-icon-right-arrow collection-pagination__icon" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect class="icon-bg" x="0.5" y="0.5" width="38" height="38" rx="19" fill="white" fill-opacity="0.5"/>
              <rect x="0.5" y="0.5" width="38" height="38" rx="19" stroke="black"/>
              <g clip-path="url(#v5-icon-right-arrow-clip)">
                <path d="M11.5 20.25H23.7422" stroke="#242F20" stroke-width="1.6"/>
                <path d="M20.9922 14L27.2419 20.2498L20.9922 26.4995" stroke="#242F20" stroke-width="1.6"/>
              </g>
              <defs>
              <clipPath id="v5-icon-right-arrow-clip">
                <rect width="17" height="16" fill="white" transform="translate(11.5 12)"/>
              </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      `;
    }

    // 挂载到页面时执行
    connectedCallback() {
      this.render();
      this.isMounted = true;

      // 事件委托：绑定在组件根节点上
      this.addEventListener('click', (e) => {
        const item = e.target.closest('[data-page]');
        if (!item) return;

        const page = parseInt(item.dataset.page);
        if (page > 0 && page <= this.total && page !== this.current) {
          // 更新属性触发重绘
          this.current = page;

          // 抛出原生事件
          this.dispatchEvent(new CustomEvent('collection:pagination-change', {
            detail: { page },
            bubbles: true
          }));
        }
      });
    }
  }
  customElements.define('collection-pagination', CollectionPagination);
})()
